import { combineReducers, compose } from 'redux'
import { createStore, applyMiddleware } from 'redux'
import thunkMiddleware from 'redux-thunk'
import immutableStateInvariantMiddleware from 'redux-immutable-state-invariant'
import { mediaList } from '../redux/mediaList/reducer'
import { appliedFilters } from '../redux/appliedFilters/reducer'
import { availableFilters } from '../redux/availableFilters/reducer'
import { navigation } from '../redux/navigation/reducer'
import { configuration } from '../redux/configuration/reducer'
import { currentMedia } from '../redux/currentMedia/reducer'
import { aside } from '../redux/aside/reducer'
import { mediaInfo } from '../redux/mediaInfo/reducer'
import { queryParams } from '../redux/queryParams/reducer'
import { notifications } from '../redux/notifications/reducer'
import { print } from '../redux/print/reducer'
import { app } from '../redux/app/reducer'
import { tableOfContents } from '../redux/tableOfContents/reducer'
import { bookmarks } from '../redux/bookmarks/reducer'
import { fetchingMedia } from '../redux/fetchingMedia/reducer'
import { canvas } from '../redux/canvas/reducer'
import { minimap } from '../redux/minimap/reducer'
import { group } from '../redux/group/reducer'
import { visualizer } from '../redux/visualizer/reducer'
import { collaborativeIndexations } from '../redux/collaborativeIndexations/reducer'
import { thumbnails } from '../redux/thumbnails/reducer'
import { share } from '../redux/share/reducer'

const reducer = combineReducers({
    mediaList,
    navigation,
    availableFilters,
    appliedFilters,
    configuration,
    currentMedia,
    aside,
    mediaInfo,
    queryParams,
    notifications,
    print,
    app,
    tableOfContents,
    bookmarks,
    fetchingMedia,
    canvas,
    minimap,
    group,
    visualizer,
    collaborativeIndexations,
    thumbnails,
    share,
})

const isDevelopmentEnv = process.env.NODE_ENV === 'development'
const isDevtoolsExtensionEnabled = typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ && isDevelopmentEnv

let composeEnhancers = compose
if(isDevtoolsExtensionEnabled)
{
    composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ trace: true, traceLimit: 25 })
}

const enhancer = composeEnhancers(
    applyMiddleware(
        thunkMiddleware,
        immutableStateInvariantMiddleware()
    ),
);

export const store = createStore(reducer, enhancer)
